import {
  ExamData,
  GenericsOptions,
  MoldeData,
  MoldesQuery,
  PracticeData,
} from "../../../../services/Exams-Moldes/types";
import LavorisService from "../../../../services/LavorisService";

export const getIsNotIncluded = <T extends { id: string }>(control: T[]) => {
  return (element: T) => !Boolean(control.find((p) => p.id === element.id));
};

export const fetchAndFilterPractices = async (
  LavorisInstance: LavorisService,
  exam: ExamData | undefined,
  molde: MoldeData | undefined,
  practicesSelected: PracticeData[] | undefined,
  patientType: string,
  isContronConsultorio: boolean = false
) => {
  
  const PATIENT_TYPES = {
    COMPANY_CANDIDATE: ["COMPANY_CANDIDATE", "CANDIDATE", "Postulante"],
    COMPANY_EMPLOYEE: ["COMPANY_EMPLOYEE", "EMPLOYEE", "Empleado"],
    PARTICULAR_CLIENT: "PARTICULAR_CLIENT",
  };
  
  function includesAnyKeyword(value: string, keywords: string[]): boolean {
    const lowercasedValue = value.toLowerCase();
    return keywords.some(keyword => lowercasedValue.includes(keyword.toLowerCase()));
  };

  const returnPatientType = () => {
    let type = ['candidate', 'employee'];
    if (includesAnyKeyword(patientType, PATIENT_TYPES.COMPANY_CANDIDATE)) return type = ['candidate'];
    if (includesAnyKeyword(patientType, PATIENT_TYPES.COMPANY_EMPLOYEE)) return type = ['employee'];
    return type
  }

  const allPractices = await LavorisInstance.TurnServices.getAllPracticesWithNoLocation(returnPatientType());
  let allPracticesItems = allPractices
  
  allPracticesItems?.filter((e: any) => e?.specialty?.alias !== "AUSENTISMO" && e?.form !== null)
  if (isContronConsultorio) {
    allPracticesItems = allPracticesItems?.filter((e: any) => e?.managerId === '1026' || e?.managerId === '2023')
  }
  
  // // Función para normalizar y eliminar mayúsculas, minúsculas y acentos
  // const normalizeString = (str: string) =>
  //   str.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');

  // if (patientType) {
  //   options = options.filter((e: any) =>
  //     !notIncluded.some(item =>
  //       normalizeString(e.name).includes(normalizeString(item))
  //     )
  //   );
  // }

  const practicesToFilter: PracticeData[] = [];

  if (exam) {
    practicesToFilter.push(...exam.practices);
  }

  if (molde) {
    practicesToFilter.push(...molde.practices);
    practicesToFilter.push(...molde.exams.map((e) => e.practices).flat());
  }

  if (practicesSelected?.length) {
    practicesToFilter.push(...practicesSelected);
  }

  return allPracticesItems.filter(getIsNotIncluded(practicesToFilter));
};

export const fetchAbsenteeInLavorisPractices = async (
  LavorisInstance: LavorisService,
  practicesSelected: PracticeData[] | undefined,

) => {

  const allPractices = await LavorisInstance.TurnServices.getAbsenteeInLavorisPractices();
  const allPracticesItems = allPractices

  const practicesToFilter: PracticeData[] = [];

  if (practicesSelected?.length) {
    practicesToFilter.push(...practicesSelected);
  }

  return allPracticesItems.filter(getIsNotIncluded(practicesToFilter));
};

export const fetchAndFilterMoldes = async (
  LavorisInstance: LavorisService,
  companyId: string,
  patientType: string,
  isContronConsultorio?: boolean
) => {
  // let moldesQuery: MoldesQuery = {};
  // let type = ['candidate'];
  const returnPatientType = () => {
    let type = ['candidate'];
    if (patientType === "COMPANY_EMPLOYEE" || patientType === "EMPLOYEE" || patientType === "Empleado") {
      type = ['employee']
    }
    return type
  }

  const moldes = await LavorisInstance.ExamsMoldes.getMoldes(companyId, returnPatientType());

  // if (patientType === "COMPANY_EMPLOYEE" || patientType === "EMPLOYEE" || patientType === "Empleado")
  //   moldesQuery = {
  //     companyId: companyId,
  //     generics: isContronConsultorio ? GenericsOptions.NO : GenericsOptions.YES,
  //   };

  // if (patientType === "COMPANY_CANDIDATE" || patientType === "CANDIDATE" || patientType === "Postulante") {
  //   moldesQuery = {
  //     companyId: companyId,
  //     generics: GenericsOptions.YES,
  //   };
  // }


  return moldes
    .map((molde) => {
      if (!molde.name) molde.name = molde.position.name;

      return molde;
    })
    .sort((a, b) => (a.name ?? "").localeCompare(b.name ?? "", "es"));
};
